module.exports = __webpack_public_path__ + "static/media/canela-light_italic.50a36101.woff";